import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default function SimpleTable({ cols, rows }) {

    return (
        <TableContainer component={Paper}>
            <Table aria-label="users">
                <TableHead>
                    <TableRow>
                        {
                            cols.map(col => (
                                <TableCell key={col}>
                                    <b>{col}</b>
                                </TableCell>
                            ))
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        {rows.map(row => (
                            <TableCell key={row}>
                                {row}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}
